import Toast from 'react-native-root-toast';
import { initialWindowMetrics } from 'react-native-safe-area-context';

import { getFieldTabBarHeight } from '../components/navigation/fieldTabBarHeight';
import { getScreenFooterHeight, getSyncBannerHeight } from '../design/screenFooterHeight';

// Bottom toasts (the library default) sit 20 pt above the bottom edge, over the tab
// bar labels and the primary button. Every Toast.show call goes through here, so
// bottom toasts are lifted above the focused screen's footer (tab bar, dock and banner)
// plus the safe-area inset, like the sync banner. Toasts that ask for another
// position keep it.
const GAP_ABOVE_FOOTER = 12;
const showToast = Toast.show;

Toast.show = (message, options = { duration: Toast.durations.SHORT }) => {
	if (options.position !== undefined && options.position !== Toast.positions.BOTTOM) {
		return showToast(message, options);
	}
	const bottomInset = initialWindowMetrics?.insets?.bottom || 0;
	const footerHeight = getFieldTabBarHeight() + getScreenFooterHeight();
	// The sync banner floats a gap above the footer; stack the toast above it too.
	const syncBannerHeight = getSyncBannerHeight();
	const syncBannerSpace = syncBannerHeight ? syncBannerHeight + GAP_ABOVE_FOOTER : 0;
	const position = -(bottomInset + footerHeight + syncBannerSpace + GAP_ABOVE_FOOTER);
	return showToast(message, { ...options, position: Math.min(position, Toast.positions.BOTTOM) });
};
